import { XhttpRequest, ShowRequestResp } from './_request.js';

const urlSessionControl = '/util/php/class.sessionControl.php';
const urlModuleUsers    = '/util/php/class.moduleUsers.php';
const urlModuleDrivers  = '/util/php/class.moduleDrivers.php';
const urlModuleNews     = '/util/php/class.moduleNews.php';
const urlModuleRaces    = '/util/php/class.moduleRaces.php';
const urlModuleResults  = '/util/php/class.moduleResults.php';
const urlSendMail       = '/util/php/sendSMTP-Mail.php';

export function showFormContact() {
    document.getElementById('HDivContact').classList.add('active');
}

export function hideFormContact() {
    document.getElementById('HDivContact').classList.remove('active');
}

export function ActiveFormContactTop(element) {
    const divElement = document.getElementById(element);
    if (divElement.classList[0] == 'active') {
        divElement.classList.remove('active');
    } else {
        divElement.classList.add('active');
    }
}

export function QuitSession() {
    fetch(urlSessionControl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: 'callFunction=LogOut',
    })
        .then(response => response.text())
        .then(data => {
            if (data.trim() == '1') {
                window.location.href = '/';
            } else {
                console.error('Logout error:', data);
                const wrongMsg = document.getElementById('WrongMessage');
                if (wrongMsg) wrongMsg.innerHTML = data;
            }
        })
        .catch(error => console.error('Request failed', error));
}

function deleteAdminRecord(urlProcessor, callFunction, recordId, confirmMessage, protectedMessage) {
    if (!confirm(confirmMessage)) return;

    fetch(urlProcessor, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: 'callFunction=' + callFunction + '&action=eliminar&attachedData=' + encodeURIComponent(recordId),
    })
        .then(response => response.text())
        .then(data => {
            const response = data.trim();
            if (response === '1') {
                window.location.reload();
            } else if (response === '2' && protectedMessage) {
                alert(protectedMessage);
            } else {
                alert(response || 'No fue posible eliminar el registro.');
            }
        })
        .catch(() => alert('No fue posible procesar la solicitud.'));
}

export function deleteUser(userId) {
    deleteAdminRecord(
        urlModuleUsers,
        'ProcessUserData',
        userId,
        '¿Eliminar este usuario?',
        'No puedes eliminar el último usuario activo.'
    );
}

export function deleteDriver(driverId) {
    deleteAdminRecord(
        urlModuleDrivers,
        'ProcessDriverData',
        driverId,
        '¿Eliminar este piloto?'
    );
}

export function deleteEnrollment(enrollmentId) {
    deleteAdminRecord(
        urlModuleDrivers,
        'ProcessEnrollerData',
        enrollmentId,
        '¿Eliminar esta inscripción?'
    );
}

export function deleteNews(newsId) {
    deleteAdminRecord(
        urlModuleNews,
        'ProcessNewsData',
        newsId,
        '¿Eliminar esta noticia?'
    );
}

export function deleteRace(raceId) {
    deleteAdminRecord(
        urlModuleRaces,
        'ProcessRaceData',
        raceId,
        '¿Eliminar esta carrera?'
    );
}

export function deleteRound(roundId) {
    deleteAdminRecord(
        urlModuleRaces,
        'ProcessRoundData',
        roundId,
        '¿Eliminar este round?'
    );
}

export function deleteResult(resultId) {
    deleteAdminRecord(
        urlModuleResults,
        'ProcessResultData',
        resultId,
        '¿Eliminar este resultado?'
    );
}

function slugifyText(value) {
    return value
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');
}

export function initNewsForms() {
    document.querySelectorAll('form[data-news-form]').forEach(form => {
        const titleInput = form.querySelector('[data-slug-source]');
        const slugInput = form.querySelector('[data-slug-target]');
        const statusMessage = document.getElementById('NewsStatusMessage');
        let slugTouched = Boolean(slugInput?.value);

        slugInput?.addEventListener('input', () => {
            slugTouched = true;
            slugInput.value = slugifyText(slugInput.value);
        });

        titleInput?.addEventListener('input', () => {
            if (!slugInput || slugTouched) return;
            slugInput.value = slugifyText(titleInput.value);
        });

        form.addEventListener('submit', event => {
            event.preventDefault();
            if (statusMessage) statusMessage.innerHTML = 'Procesando...';

            const formData = new FormData(form);
            formData.append('callFunction', 'ProcessNewsData');
            formData.append('action', form.dataset.action || '');

            fetch(urlModuleNews, {
                method: 'POST',
                body: formData,
            })
                .then(response => response.json())
                .then(data => {
                    if (data.statusEvent == '1') {
                        if (statusMessage) statusMessage.innerHTML = data.messageResponse;
                        if (data.redirect) {
                            setTimeout(() => {
                                window.location.href = data.redirect;
                            }, 800);
                        }
                    } else if (statusMessage) {
                        statusMessage.innerHTML = data.messageResponse || 'No fue posible guardar la noticia.';
                    }
                })
                .catch(() => {
                    if (statusMessage) statusMessage.innerHTML = 'No fue posible procesar la solicitud.';
                });
        });
    });
}

export function initResultTotalCalculator() {
    const form = document.getElementById('FormResult');
    if (!form) return;

    const scoreFields = ['heat_1', 'heat_2', 'heat_3', 'prefinal', 'final', 'adicionales'];
    const penaltyInput = document.getElementById('penalizaciones');
    const totalInput = document.getElementById('total');
    const inputs = scoreFields
        .map(fieldId => document.getElementById(fieldId))
        .filter(Boolean);

    if (!penaltyInput || !totalInput || inputs.length !== scoreFields.length) return;

    const readNumber = input => {
        const value = Number(input.value);
        return Number.isFinite(value) ? value : 0;
    };

    const updateTotal = () => {
        const subtotal = inputs.reduce((sum, input) => sum + readNumber(input), 0);
        const total = Math.max(0, subtotal - readNumber(penaltyInput));
        totalInput.value = String(total);
    };

    [...inputs, penaltyInput].forEach(input => {
        input.addEventListener('input', updateTotal);
        input.addEventListener('change', updateTotal);
    });
    updateTotal();
}

export function ToggleShowwPass(event, idPass) {
    event.preventDefault();
    const pass = document.getElementById(idPass);
    pass.type = pass.type == 'password' ? 'text' : 'password';
}

export function fillFormDates(objDates) {
    for (const x in objDates) {
        const elem = document.getElementById(x);
        if (!elem) continue;
        if (['text', 'email', 'password', 'number'].includes(elem.type)) {
            elem.value = objDates[x].value;
        } else if (elem.type == 'checkbox') {
            elem.checked = objDates[x].value == 1;
        } else if (elem.type == 'select-one') {
            elem.value = objDates[x].value;
        } else if (elem.type == 'textarea') {
            elem.value = objDates[x].value.replace(/<br><br>/g, '\n\n');
        }
    }
}

export function LoadAvailableNumbers(inputNumbers) {
    const category = document.getElementById('FEnrCategoria')?.value || '';
    const round = document.getElementById('FEnrRonda')?.value || '';
    const enrollment = document.getElementById('FEnrEnrolerId')?.value || '';
    const select = document.getElementById(inputNumbers);

    if (category !== '' && round !== '') {
        const requestData = JSON.stringify({ category, round, enrollment });
        const sendFormData = 'callFunction=LoadNumbersList&attachedData=' + encodeURIComponent(requestData);
        XhttpRequest(urlModuleDrivers, inputNumbers, inputNumbers, sendFormData, _loadAvailableNumbersResp);
        select.disabled = false;
    } else {
        select.disabled = true;
        select.innerHTML = '<option value="">Selecciona categoría y round</option>';
    }
}

function _loadAvailableNumbersResp(xhttp, idForResponse) {
    const select = document.getElementById(idForResponse);
    select.innerHTML = '<option value="">Selecciona un número</option>';
    const responseDates = JSON.parse(xhttp.responseText);
    if (responseDates) {
        responseDates.forEach(numero => {
            const opt = document.createElement('option');
            opt.value = numero;
            opt.textContent = numero;
            select.appendChild(opt);
        });
        select.disabled = false;
    }
}

export function ValidateSendDates(event, formRequest, inputPrefix, action) {
    event.preventDefault();

    const valMail  = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const valPhone = /^[0-9\s]+$/;

    let userData       = [];
    let isFormValid    = true;
    let showMessage    = '';
    const statusMessage = inputPrefix + 'StatusMessage';
    const dataUser     = document.forms[formRequest].querySelectorAll('input[data-ref="userDate"], textarea[data-ref="userDate"], select[data-ref="userDate"]');
    const processedNames = new Set();

    for (const el of dataUser) {
        if (el.type === 'submit') continue;
        const name = el.name;
        if (processedNames.has(name) && el.type === 'radio') continue;
        processedNames.add(name);

        let value = el.value;
        if (el.type === 'radio') {
            const selected = document.querySelector(`input[name="${name}"]:checked`);
            value = selected ? selected.value : '';
        } else if (el.type === 'checkbox') {
            value = el.checked ? (el.value || '1') : '0';
        }

        userData.push({
            dataName:  name,
            dataValue: value,
            dataType:  el.type,
            dataLabel: el.dataset.name || el.getAttribute('data-label') || name,
            required:  el.required,
            elementId: el.id,
        });
    }

    for (const element of userData) {
        const inputUI = element.dataType === 'radio'
            ? document.getElementsByName(element.dataName)[0]
            : document.getElementById(element.elementId);

        if (!inputUI) continue;
        inputUI.classList.remove('form-field--error');
        const fieldWrapper = inputUI.closest('.form-field, .divBox');
        if (fieldWrapper) fieldWrapper.classList.remove('form-field--error');

        if (element.required && (!element.dataValue || element.dataValue.toString().trim() === '')) {
            showMessage = 'El campo ' + element.dataLabel + ' es obligatorio';
            isFormValid = false;
            if (element.dataType === 'radio') {
                inputUI.closest('.form-field, .divBox').classList.add('form-field--error');
            } else {
                inputUI.classList.add('form-field--error');
                inputUI.focus();
            }
            break;
        }

        if (element.dataValue) {
            if (element.dataType === 'email' && !valMail.test(element.dataValue)) {
                showMessage = 'Formato de correo no válido en ' + element.dataLabel;
                inputUI.classList.add('form-field--error');
                isFormValid = false;
                break;
            }
            if (element.dataType === 'tel' && !valPhone.test(element.dataValue)) {
                showMessage = 'El teléfono en ' + element.dataLabel + ' solo debe contener números';
                inputUI.classList.add('form-field--error');
                isFormValid = false;
                break;
            }
        }

        if ((formRequest === 'FormRegistroU' || formRequest === 'FormNewPass') && isFormValid) {
            const p1   = formRequest === 'FormRegistroU' ? 'FReuPass' : 'FResPass';
            const p2   = p1 + '_validate';
            const pass1 = document.getElementById(p1);
            const pass2 = document.getElementById(p2);
            if (pass1 && pass2 && pass1.value !== pass2.value) {
                showMessage = 'Las contraseñas no coinciden.';
                pass1.classList.add('form-field--error');
                isFormValid = false;
                break;
            }
        }
    }

    if (!isFormValid) {
        document.getElementById(statusMessage).innerHTML = `<span style="color:red;">${showMessage}</span>`;
        return;
    }

    document.getElementById(statusMessage).innerHTML = 'Procesando...';
    let sendFormData = '';

    if (formRequest === 'FormLogin') {
        sendFormData = 'callFunction=LogIn&attachedData=' + encodeURIComponent(JSON.stringify(userData));
        XhttpRequest(urlSessionControl, formRequest, statusMessage, sendFormData, _loginResp);
    } else if (formRequest === 'FormRegistroU') {
        sendFormData = 'callFunction=ProcessUserData&action=' + action + '&attachedData=' + encodeURIComponent(JSON.stringify(userData));
        XhttpRequest(urlModuleUsers, formRequest, statusMessage, sendFormData, ShowRequestResp);
    } else if (formRequest === 'FormDriver') {
        sendFormData = 'callFunction=ProcessDriverData&action=' + action + '&attachedData=' + encodeURIComponent(JSON.stringify(userData));
        XhttpRequest(urlModuleDrivers, formRequest, statusMessage, sendFormData, ShowRequestResp);
    } else if (formRequest === 'FormEnroller') {
        sendFormData = 'callFunction=ProcessEnrollerData&action=' + action + '&attachedData=' + encodeURIComponent(JSON.stringify(userData));
        XhttpRequest(urlModuleDrivers, formRequest, statusMessage, sendFormData, ShowRequestResp);
    } else if (formRequest === 'FormRace') {
        sendFormData = 'callFunction=ProcessRaceData&action=' + action + '&attachedData=' + encodeURIComponent(JSON.stringify(userData));
        XhttpRequest(urlModuleRaces, formRequest, statusMessage, sendFormData, ShowRequestResp);
    } else if (formRequest === 'FormRound') {
        sendFormData = 'callFunction=ProcessRoundData&action=' + action + '&attachedData=' + encodeURIComponent(JSON.stringify(userData));
        XhttpRequest(urlModuleRaces, formRequest, statusMessage, sendFormData, ShowRequestResp);
    } else if (formRequest === 'FormResult') {
        sendFormData = 'callFunction=ProcessResultData&action=' + action + '&attachedData=' + encodeURIComponent(JSON.stringify(userData));
        XhttpRequest(urlModuleResults, formRequest, statusMessage, sendFormData, ShowRequestResp);
    } else if (formRequest === 'FormPassRecover') {
        sendFormData = 'callFunction=ProcessRecoveryPass&action=recoveryPass&attachedData=' + encodeURIComponent(JSON.stringify(userData));
        XhttpRequest(urlModuleUsers, formRequest, statusMessage, sendFormData, ShowRequestResp);
    } else if (formRequest === 'FormNewPass') {
        sendFormData = 'callFunction=ProcessRecoveryPass&action=resetPass&attachedData=' + encodeURIComponent(JSON.stringify(userData));
        XhttpRequest(urlModuleUsers, formRequest, statusMessage, sendFormData, ShowRequestResp);
    } else {
        sendFormData = 'formRequest=' + formRequest + '&userData=' + encodeURIComponent(JSON.stringify(userData));
        XhttpRequest(urlSendMail, formRequest, statusMessage, sendFormData, ShowRequestResp);
    }

    function _loginResp(xhttp, idForResponse, statusMessage) {
        try {
            const responseDates = JSON.parse(xhttp.responseText);
            if (responseDates.statusEvent == '1') {
                document.getElementById(formRequest).innerHTML = `<div class='info-msg'>${responseDates.messageResponse}</div>`;
                setTimeout(() => location.reload(), 1500);
            } else {
                document.getElementById(statusMessage).innerHTML = responseDates.messageResponse;
            }
        } catch (e) {
            console.error('Error en respuesta JSON:', e);
        }
    }
}
